import React from 'react';
import Icon from '../../../components/AppIcon';

const WhyUEExists = () => {
  const problems = [
    {
      icon: 'EyeOff',
      title: 'Informal Labor Economy',
      description: 'Over 60% of Latin American workers operate in the informal economy, lacking visibility and growth opportunities.',
    },
    {
      icon: 'Search',
      title: 'Lack of Discoverability',
      description: 'Quality service providers struggle to reach customers beyond word-of-mouth, limiting their market potential.',
    },
    {
      icon: 'CreditCard',
      title: 'No Payment Infrastructure',
      description: 'Most micro-businesses operate cash-only, missing digital payment benefits and financial inclusion.',
    },
    {
      icon: 'Calendar',
      title: 'No Appointment Management',
      description: 'Manual scheduling leads to no-shows, double bookings, and lost revenue for service providers.',
    },
    {
      icon: 'Database',
      title: 'No Local Data Infrastructure',
      description: 'Zero visibility into service economy metrics prevents informed business and policy decisions.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-wide mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <p className="text-sm font-medium text-accent uppercase tracking-wider mb-3">
            The Problem
          </p>
          <h2 className="text-display text-foreground mb-6">
            Why UE Exists
          </h2>
          <p className="text-body-large">
            Latin America's $1.2 trillion service economy operates largely in the shadows.
            We're building the infrastructure to formalize, digitize, and scale this massive opportunity.
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="group p-6 bg-muted rounded-brand hover:bg-white hover:shadow-corporate-md border border-transparent hover:border-border transition-all duration-300"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-brand-sm flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300">
                <Icon name={problem.icon} size={24} className="text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                {problem.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}

          {/* Solution Card */}
          <div className="p-6 bg-primary rounded-brand text-white">
            <div className="w-12 h-12 bg-white/10 rounded-brand-sm flex items-center justify-center mb-4">
              <Icon name="Layers" size={24} className="text-white" />
            </div>
            <h3 className="text-lg font-semibold mb-2">
              Our Solution
            </h3>
            <p className="text-sm text-white/80 leading-relaxed mb-4">
              One unified platform that brings discovery, booking, payments, ratings, and business intelligence together.
            </p>
            <a
              href="/technology"
              className="inline-flex items-center text-sm font-medium text-white hover:text-white/80 transition-colors"
            >
              Learn about our platform
              <Icon name="ArrowRight" size={16} className="ml-2" />
            </a>
          </div>
        </div>

        {/* Impact Statement */}
        <div className="mt-16 pt-16 border-t border-border">
          <div className="grid lg:grid-cols-3 gap-8 items-center">
            <div className="lg:col-span-2">
              <blockquote className="text-2xl font-medium text-foreground leading-relaxed">
                "We are not a booking app. We are infrastructure for a trillion-dollar informal economy."
              </blockquote>
            </div>
            <div className="text-right">
              <a
                href="/impact"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:text-primary-light transition-colors"
              >
                Read our impact report
                <Icon name="ArrowRight" size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUEExists;
